import React, { useState, useEffect, useRef } from 'react';
import './chatbot.css'; // Make sure this CSS file exists and is styled

const chatbotData = {
  "Events": {
    questions: {
      "What kind of events are hosted?": "We host Chess, bowling, BGMI and more gaming tournaments.",
      "How to register for an event?": "You can register via the Events tab on our website. Choose your event and click 'Book Now'.",
      "Is there a fee to participate?": "Some events are free, others have a registration fee. Details are on the event page.",
      "Can I register on behalf of my friends?": "Yes, team registrations are allowed for some events.",
      "Where are events held?": "We have events in multiple cities including Mumbai, Mangalore, Hyderabad, and Delhi NCR."
    }
  },
  "Ambassador Club": {
    questions: {
      "What is the Smaaash Ambassador Club?": "It's a club for students who promote Smaaash in their college and get exclusive perks.",
      "How can I join the club?": "Go to the Ambassador Club tab and click on 'Register Now'. Fill in the required form.",
      "Benefits of being an ambassador?": "As a Smaaash Ambassador, you get 5,000 game credits, exclusive vouchers, and access to monetary & rewards-based incentives through points, sales, and contests — plus insider perks, event access, and recognition across our platforms.",
      "Is there any eligibility criteria?": "You just need to be a college student who’s enthusiastic, creative, and ready to have fun.",
      "Can I leave the club anytime?": "Yes, though we encourage at least 6 months of participation."
    }
  }
};

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [stage, setStage] = useState("topics");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", query: "" });
  const [, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const toggleChat = () => setIsOpen(!isOpen);

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic);
    setStage("questions");
    const welcome = { sender: "bot", text: `Here are some FAQs about "${topic}"` };
    setMessages((prev) => [...prev, welcome]);
  };

  const handleQuestionClick = (question, answer) => {
    setMessages((prev) => [
      ...prev,
      { sender: "user", text: question },
      { sender: "bot", text: answer }
    ]);
  };

  const handleAskNew = () => {
    setStage("form");
    setMessages((prev) => [
      ...prev,
      { sender: "bot", text: "Please provide your name, email, and your question. Our team will respond by the next working day via email." }
    ]);
  };

  const handleFormSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name || !formData.email || !formData.query) {
      alert("Please fill out all fields.");
      return;
    }

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email.");
      return;
    }

    try {
      setIsSubmitting(true);

      const res = await fetch("https://esmaaash.in/esmaaash_web/backend/api/send_query.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setFormSubmitted(true);
        setMessages((prev) => [
          ...prev,
          { sender: "bot", text: "Thank you! We've received your question and will get back to you by the next working day." }
        ]);
        setFormData({ name: "", email: "", query: "" });
        setStage("done");
      } else {
        alert("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Form submission failed:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetChat = () => {
    setMessages([]);
    setStage("topics");
    setSelectedTopic("");
    setFormSubmitted(false);
  };

 return (
  <>
    <button
      onClick={toggleChat}
      className="chatbot-toggle"
      aria-label="Toggle chatbot"
    >
      💬
    </button>

    <div className={`chatbot-container ${isOpen ? "open" : ""}`}>
      <div className="chatbot-header">
        <span>Help Center</span>
<button 
    onClick={toggleChat} 
    aria-label="Close chat" 
    style={{
        background: "none",
        border: "none",
        fontSize: "20px",
        cursor: "pointer",
        position: "absolute",
        top: "10px",
        right: "10px",
        color: "#333"
    }}
>
    ✖
</button>
      </div>

      <div className="chatbot-messages">
        {messages.map((msg, i) => (
          <div key={i} className={`chatbot-message ${msg.sender}`}>
            {msg.text}
          </div>
        ))}

        {stage === "topics" && (
          <div className="options">
            <p className="chatbot-message bot">Choose a topic:</p>
            {Object.keys(chatbotData).map((topic) => (
              <button key={topic} onClick={() => handleTopicClick(topic)}>{topic}</button>
            ))}
          </div>
        )}

        {stage === "questions" && selectedTopic && (
          <>
            {Object.entries(chatbotData[selectedTopic].questions).map(([q, a]) => (
              <button key={q} onClick={() => handleQuestionClick(q, a)}>{q}</button>
            ))}
            <button onClick={handleAskNew}>Ask something else</button>
            <button onClick={resetChat}>🔙 Back to Topics</button>
          </>
        )}

        {stage === "form" && (
          <div className="query-form">
            <input
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
              type="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
            <textarea
              placeholder="Your Question"
              value={formData.query}
              onChange={(e) => setFormData({ ...formData, query: e.target.value })}
            />
            <button onClick={handleFormSubmit} disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
            <button onClick={resetChat}>🔙 Back to Topics</button>
          </div>
        )}

        {stage === "done" && (
          <button onClick={resetChat}>🔁 Start Over</button>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  </>
);


}